<script setup lang="ts">
import WizardTabWithSidebar from '../WizardTabWithSidebar.vue'
import BaseButtonPrimary from '../../base/BaseButtonPrimary.vue'
import { inject } from 'vue'
import NaturalLegalSelectTab from './NaturalLegalSelectTab.vue'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import WizardHeader from '../WizardHeader.vue'
import { usePersonalAccountFormState } from '../../../utilities/account/useAccountFormPersonal'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { CashIcon } from '@heroicons/vue/solid'
import FatcaDeclarationForm from './form/FatcaDeclarationForm.vue'

const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

const formState = usePersonalAccountFormState()
const { naturalProfile: account } = usePersonalAccountDataState()

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<template>
    <WizardTabWithSidebar
        :previous-tab="NaturalLegalSelectTab"
        :next-tab="NaturalLegalSelectTab"
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings.fatca_declaration')" :icon="CashIcon"></WizardHeader>
            <div class="px-4 sm:px-6">
                <FatcaDeclarationForm></FatcaDeclarationForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="
                    usePersonalAccountDataState().saving ||
                    formState.hasValidationErrors ||
                    account.compliance_profiles.esac.fatca_declaration.us_citizen_or_resident === 'yes'
                "
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }} </BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.natural_fatca') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<style scoped></style>
